import { Button, Modal } from "antd";
import Checkbox, { CheckboxChangeEvent } from "antd/lib/checkbox/Checkbox";
import qs from "qs";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { RouteChildrenProps, useHistory } from "react-router";
import { AutoRefreshCalculationReportProcess, LeftSiderBarWith, ReportAnalysisProcessEnum, REPORTQUERYPARAMS, ReportStatesEnum, ScenarioFrontierFileType } from "../../../../constants/constants";
import { ROUTE_PATHS } from "../../../../constants/url-config";
import { MessageType } from "../../../../models/common/response-message";
import { FrontierScenarioReportModel, ScenarioFrontierFileModel, ScenarioFrontierModel, ScenarioFrontierUploadFileModel } from "../../../../models/scenario-frontier.model";
import { setActions, setStatus, setTitle } from "../../../../redux/actions/header.action";
import { ScenarioFrontierService } from "../../../../services/scenario-frontier.service";
import HISTORY from "../../../../utils/history.helper";
import i18n from "../../../../utils/i18n";
import UTIL from "../../../../utils/utils";
import { showMessage } from "../../../atoms/notification/notification";
import { RouterPrompt } from "../../../atoms/router-promt";
import { quarters } from "../select-period";
import CalculationProgress from "./caculation-progress";
import "./index.scss";
import FrontierOutput from "./output";
import ReportError from "./report-error";
import FrontierScenarioReport from "./scenario-report";
import FrontierUploadFile from "./upload-file";

enum CreateReportStep {
    ScenarioReport = 1,
    AssetGrowthReport,
    UploadFile,
    Calculation,
    Output
}


interface Props extends RouteChildrenProps<{ id: string }> { }

const FrontierNewReport = (props: Props) => {

    const dispatch = useDispatch();
    const [curentStep, setCurentStep] = useState<CreateReportStep>(0);
    const [concentrationStressCalculating, setConcentrationStressCalculating] = useState<boolean>(Boolean);
    const [report, setReport] = useState<ScenarioFrontierModel>({
        fiscalYear: 0,
        frontierInputAssetGrowthReports: [],
        frontierInputScenarioReports: [],
        frontierInputFiles: [],
        quarter: 0,
        includeConcentrationStressTest: false,
        process_state: "",
        frontierOutputFiles: []
    });
    const [inputFile, setInputFile] = useState<ScenarioFrontierFileModel>();
    const [fileLoading, setFileLoading] = useState(false);
    const [fileError, setFileError] = useState<string>();
    const getReportInterval = useRef<NodeJS.Timeout>();
    const [reportError, setReportError] = useState(false);

    const [showPrompt, setShowPrompt] = useState(false);
    const history = useHistory();
    const scenarioReportsUnsaved = useRef<FrontierScenarioReportModel[]>();
    const grownthAssetReportsUnsaved = useRef<FrontierScenarioReportModel[]>();
    const currentStepRef = useRef<CreateReportStep>(0);
    const isRequesting = useRef<boolean>(false);

    const stepsContent = [
        {
            step: CreateReportStep.ScenarioReport,
            content: <FrontierScenarioReport
                data={report.frontierInputScenarioReports}
                title={i18n.t("ScenarioFrontier.lbScenarioReport")}
                year={report.fiscalYear}
                saveItem={(item) => saveScenarioReport(item)}
                updateEditItems={(items) => scenarioReportUpdateUnsavedData(items)} />
        },
        {
            step: CreateReportStep.AssetGrowthReport,
            content: <FrontierScenarioReport
                data={report.frontierInputAssetGrowthReports}
                title={i18n.t("ScenarioFrontier.lbAssetGrowthReport")}
                year={report.fiscalYear}
                saveItem={(item) => saveAssetGrowthReport(item)}
                updateEditItems={(items) => grownthAssetReportUpdateUnsavedData(items)} />
        },
        {
            step: CreateReportStep.UploadFile,
            content: <FrontierUploadFile
                uploadFile={(model) => uploadInputFile(model)}
                fileData={inputFile}
                loading={fileLoading}
                errorMessage={fileError}
                deleteFile={() => deleteFile()} />
        },
        {
            step: CreateReportStep.Calculation,
            content: <CalculationProgress
                title={concentrationStressCalculating ? i18n.t("ScenarioFrontier.ttConcentrationStressCaculation") : i18n.t("ScenarioFrontier.ttCaculation")}
                des={concentrationStressCalculating ? i18n.t("ScenarioFrontier.lbConcentrationStressCaculationDes") : i18n.t("ScenarioFrontier.ttCaculation")} />
        },
        {
            step: CreateReportStep.Output,
            content: <FrontierOutput id={report.id}
                year={report.fiscalYear}
                quarter={report.quarter}
                data={report.frontierOutputFiles}
                includeConcentrationStressTest={report.includeConcentrationStressTest} />
        }
    ]

    const scenarioReportUpdateUnsavedData = (items: FrontierScenarioReportModel[]) => {
        scenarioReportsUnsaved.current = items;
        setShowPrompt(needShowRouterPromt());
    }

    const grownthAssetReportUpdateUnsavedData = (items: FrontierScenarioReportModel[]) => {
        grownthAssetReportsUnsaved.current = items;
        setShowPrompt(needShowRouterPromt());

    }

    const uploadInputFile = async (model: ScenarioFrontierUploadFileModel) => {

        setFileError(undefined);
        setInputFile(undefined);

        if (report.id) {
            model.reportId = report.id;
            setFileLoading(true);
            ScenarioFrontierService.uploadInputFile(model).then(res => {
                setInputFile(res.data);
            }).catch(error => {
                setFileError(error?.response?.data?.message ||
                    "Please retry the action. If the error persists contact your administrator");
            }).finally(() => setFileLoading(false));
        }
    }

    const deleteFile = async () => {

        if (inputFile) {
            await ScenarioFrontierService.deleteInputFile(inputFile.id);
            setInputFile(undefined);
            setFileError(undefined);
        } else {
            setFileError(undefined);
        }
    }

    const goback = () => {
        if (curentStep > 1) {
            setCurentStep(pre => pre - 1);
        }
    }

    const next = async () => {

        switch (curentStep) {
            case CreateReportStep.ScenarioReport:
            case CreateReportStep.AssetGrowthReport:
                if (needShowRouterPromt()) {
                    Modal.confirm({
                        content: i18n.t("ScenarioFrontier.ttContinueConfimation"),
                        onOk: () => setCurentStep(pre => pre + 1),
                        icon: '',
                        width: 304,
                        okText: i18n.t("ScenarioFrontier.btnOkContinue"),
                        cancelText: i18n.t("Global.lbCancel")
                    })
                } else {
                    setCurentStep(pre => pre + 1)
                }
                break;
            case CreateReportStep.UploadFile:
                if (!inputFile) {
                    showMessage({
                        message: "Please upload file!",
                        type: MessageType.error
                    });
                    return;
                }

                if (report.id) {
                    setCurentStep(CreateReportStep.Calculation);
                    ScenarioFrontierService.generateResult(report.id);
                    updateStatus(ReportStatesEnum.Submitting);
                    calculationProcess();
                }
                break;
            default:
                setCurentStep(pre => pre + 1);
                break;
        }
    }

    const calculationProcess = () => {
        getReportInterval.current = setInterval(() => {
            if (!isRequesting.current) {
                generateReport();
            }
        }, AutoRefreshCalculationReportProcess)
    }

    const renderActions = () => <Button onClick={() => { saveAndContiueLater() }} htmlType="button" type="default" shape="round" block >{i18n.t("ScenarioFrontier.btnSaveContinueLater")}</Button>

    const submitForApproval = async () => {
        if (report.id) {
            await ScenarioFrontierService.submitForApproval(report.id);
            history.push(ROUTE_PATHS.ScenarioFrontierReports);
        }
    }

    const startOver = async () => {
        const res = await ScenarioFrontierService.startOver(report.fiscalYear, report.quarter);
        updateReportData(res.data);
        setReportError(false);
    }

    const saveAndContiueLater = async () => {
        setShowPrompt(false);
        await saveData();
        HISTORY.push(ROUTE_PATHS.ScenarioFrontierReports);
    }

    const saveScenarioReport = async (item: FrontierScenarioReportModel) => {
        await ScenarioFrontierService.updateScenarioReport(item);
    }

    const saveScenarioReports = async (items: FrontierScenarioReportModel[]) => {
        await ScenarioFrontierService.updateScenarioReports(items);
    }

    const saveAssetGrowthReport = async (item: FrontierScenarioReportModel) => {
        await ScenarioFrontierService.assetGrowthReport(item);
    }

    const saveAssetGrowthReports = async (items: FrontierScenarioReportModel[]) => {
        await ScenarioFrontierService.assetGrowthReports(items);
    }

    const checkboxChange = async (e: CheckboxChangeEvent) => {

        if (report && report.id) {
            await ScenarioFrontierService.includeConcentrationStressTest(report.id, e.target.checked);
            report.includeConcentrationStressTest = e.target.checked;
            setReport({ ...report });
            if (e.target.checked) {
                setConcentrationStressCalculating(true);
                setCurentStep(CreateReportStep.Calculation);
                await new Promise(resolve => setTimeout(() => {

                    setCurentStep(pre => {
                        return pre + 1
                    });

                    resolve(0);
                }, 2000));
                setConcentrationStressCalculating(false);
                const concentrationStressTestElement = document.getElementById(ScenarioFrontierFileType.SFSB_RESULT_6);
                if (concentrationStressTestElement) {
                    const y = concentrationStressTestElement.getBoundingClientRect().top + window.scrollY;
                    window.scroll({
                        top: y - 150,
                    });
                    // concentrationStressTestElement.scrollIntoView();
                }
            }

        }
    }

    const updateStatus = (state: string) => {
        const dom = UTIL.getLossStatesDOM(state);
        const status = <span className="text-status" style={{ color: dom.color, backgroundColor: dom.bgColor }}>
            {dom.text}
        </span>
        dispatch(setStatus(status));
    }

    const generateReport = () => {
        isRequesting.current = true;
        ScenarioFrontierService.generateReport(report, !getReportInterval.current).then(res => {
            const data = res.data;
            setReportError(false);
            updateReportData(data);
        }).catch((error) => {
            setReportError(true);
            updateReportData(report);
            if (getReportInterval.current) {
                clearInterval(getReportInterval.current);
            }
        }).finally(() => {
            isRequesting.current = false;
        });
    }

    const updateReportData = (data: ScenarioFrontierModel) => {
        setReport(data);
        dispatch(setTitle(`Scenario Report - ${data.fiscalYear} - ${quarters.find(x => x.value === data.quarter)?.text}`));
        if (data.frontierInputFiles && data.frontierInputFiles.length) {
            setInputFile(data.frontierInputFiles[0]);
        }

        switch (data.process_state) {
            case ReportAnalysisProcessEnum.Processing:
                setCurentStep(CreateReportStep.Calculation);
                if (!getReportInterval.current) {
                    calculationProcess();
                }
                break;
            case ReportAnalysisProcessEnum.Processed:
                if (getReportInterval.current) {
                    clearInterval(getReportInterval.current);
                }
                setCurentStep(CreateReportStep.Output);
                break;
            case ReportAnalysisProcessEnum.error:
                if (getReportInterval.current) {
                    clearInterval(getReportInterval.current);
                }
                setReportError(true);
                break;
            default:
                setCurentStep(CreateReportStep.ScenarioReport);
                break;
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const needShowRouterPromt = (): boolean => {
        return ((curentStep === CreateReportStep.ScenarioReport && !!scenarioReportsUnsaved.current && scenarioReportsUnsaved.current.length > 0) ||
            (curentStep === CreateReportStep.AssetGrowthReport && !!grownthAssetReportsUnsaved.current && grownthAssetReportsUnsaved.current.length > 0))
    }

    const onRouterPromtOk = async () => {
        setShowPrompt(false);
        await saveData();
        return true;
    }

    const saveData = async () => {
        if (currentStepRef.current === CreateReportStep.ScenarioReport) {
            if (scenarioReportsUnsaved.current && scenarioReportsUnsaved.current.length > 0) {
                await saveScenarioReports(scenarioReportsUnsaved.current);
            }
        } else if (currentStepRef.current === CreateReportStep.AssetGrowthReport) {
            if (grownthAssetReportsUnsaved.current && grownthAssetReportsUnsaved.current.length > 0) {
                await saveAssetGrowthReports(grownthAssetReportsUnsaved.current);
            }
        }
    }

    const onRouterPromtCancel = async () => {
        setShowPrompt(false);
        return true;
    }

    useEffect(() => {
        if (report.submit_state) {
            updateStatus(report.submit_state);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [report.submit_state])

    useEffect(() => {
        const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });
        try {
            report.fiscalYear = Number(query[REPORTQUERYPARAMS.year]);
            report.quarter = Number(query[REPORTQUERYPARAMS.quarter]);
        } catch (error) {
            console.error("Can not convert Fiscal Year and Quarter from query params");
        }

        if (!report.fiscalYear || !report.quarter) {
            HISTORY.push({
                pathname: ROUTE_PATHS.ScenarioFrontier,
                state: { nextPathname: ROUTE_PATHS.ScenarioFrontierNewReport }
            });
            return;
        }

        generateReport();

        dispatch(setActions(renderActions()));

        return () => {
            dispatch(setTitle(""));
            dispatch(setActions(null));
            dispatch(setStatus(null));
            if (getReportInterval.current) {
                clearInterval(getReportInterval.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, props.location.search])

    useEffect(() => {
        setShowPrompt(needShowRouterPromt());
    }, [curentStep, needShowRouterPromt]);

    useEffect(() => {
        currentStepRef.current = curentStep;
    }, [curentStep])

    return (
        reportError ? <ReportError startOver={startOver} quarter={quarters.find(x => x.value == report.quarter)?.text} year={report.fiscalYear} /> :
            <div className="frontier-new-report">

                {stepsContent.map(x => (
                    <div className={`step-content${x.step === curentStep ? "" : " hidden"}`} key={x.step}>
                        {x.content}
                    </div>
                ))}

                {
                    curentStep !== CreateReportStep.Calculation &&
                    <div className="fixed-action" style={{ left: LeftSiderBarWith }}>
                        {
                            (curentStep > CreateReportStep.ScenarioReport && curentStep < CreateReportStep.Calculation) && <Button type="default" shape="round" onClick={goback}>
                                {i18n.t("ScenarioFrontier.btnGoback")}
                            </Button>
                        }

                        {
                            (curentStep > CreateReportStep.Calculation) && <Button type="default" shape="round" onClick={startOver}>
                                {i18n.t("ScenarioFrontier.btnStartOver")}
                            </Button>
                        }

                        {
                            curentStep < CreateReportStep.Calculation &&
                            <Button type="primary" shape="round" onClick={next}>
                                {i18n.t("ScenarioFrontier.btnNext")}
                            </Button>
                        }

                        {
                            (curentStep === CreateReportStep.Output) &&
                            < Button type="primary" shape="round" onClick={submitForApproval}>
                                {i18n.t("ScenarioFrontier.btnSubmitForApproval")}
                            </Button>
                        }

                        {
                            curentStep === CreateReportStep.Output &&
                            <Checkbox checked={report.includeConcentrationStressTest} onChange={(e) => checkboxChange(e)}> {i18n.t("ScenarioFrontier.lbIncludeConcentrationStressTest")} </Checkbox>
                        }

                    </div>
                }

                <RouterPrompt
                    when={showPrompt}
                    title={i18n.t("ScenarioFrontier.ttPromt")}
                    cancelText={i18n.t("ScenarioFrontier.btnDiscard")}
                    okText={i18n.t("ScenarioFrontier.btnSave")}
                    onOK={onRouterPromtOk}
                    onCancel={onRouterPromtCancel}
                />
            </div>
    )
}

export default FrontierNewReport;